import type { CmsPosGameConfiguration } from '#src/interfaces/CmsConfig'

type PosGameConfigurationView = {
  childId: string | undefined
  color: string | undefined
  frameId: string | undefined
  icon: string | undefined
}

const createPosGameConfiguration = (
  config: CmsPosGameConfiguration | null | undefined
): PosGameConfigurationView => {
  const childId = config?.childId ? config.childId : undefined
  const color = config?.color ? config.color : undefined
  const frameId = config?.frameId ? config.frameId : undefined
  const icon = config?.icon ? config.icon : undefined

  return {
    childId,
    color,
    frameId,
    icon
  }
}

export type { PosGameConfigurationView }
export { createPosGameConfiguration }
